import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSidePanel } from './SidePanel.definition';
import { chameleonSidePanelActions } from './SidePanelActions.definition';
import { chameleonSvg } from '../Svg';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonSidePanel({ prefix }), chameleonSidePanelActions({ prefix }), chameleonSvg({ prefix }));
}
